export function TagIcon({ className }: { className?: string }) {
  return (
    <div style={{ padding: "4px" }}>
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.51334 0.0112121L2.30634 0.611212C1.87786 0.672724 1.4809 0.871594 1.17508 1.17795C0.869265 1.48431 0.671097 1.88162 0.610343 2.31021L0.0103422 6.51721C-0.0119238 6.67083 0.00187593 6.82752 0.0506483 6.97487C0.0994206 7.12223 0.181827 7.25621 0.291342 7.36621L7.18634 14.2602C7.27913 14.3532 7.38933 14.4269 7.51065 14.4772C7.63196 14.5275 7.76201 14.5534 7.89334 14.5534C8.02468 14.5534 8.15472 14.5275 8.27604 14.4772C8.39735 14.4269 8.50755 14.3532 8.60034 14.2602L14.2573 8.60321C14.4448 8.41568 14.5501 8.16138 14.5501 7.89621C14.5501 7.63105 14.4448 7.37674 14.2573 7.18921L7.36234 0.293212C7.25262 0.183211 7.11873 0.100345 6.97134 0.051214C6.82395 0.00208278 6.66712 -0.011957 6.51334 0.0102122V0.0112121ZM5.86634 5.86821C5.71211 6.02501 5.52836 6.14971 5.32569 6.23513C5.12302 6.32054 4.90544 6.36499 4.6855 6.36589C4.46557 6.3668 4.24763 6.32415 4.04426 6.2404C3.8409 6.15665 3.65613 6.03347 3.50061 5.87795C3.34509 5.72243 3.2219 5.53766 3.13815 5.33429C3.05441 5.13092 3.01176 4.91299 3.01266 4.69305C3.01357 4.47312 3.05801 4.25554 3.14343 4.05287C3.22885 3.8502 3.35355 3.66645 3.51034 3.51221C3.8229 3.19965 4.24682 3.02406 4.68884 3.02406C5.13087 3.02406 5.55478 3.19965 5.86734 3.51221C6.1799 3.82477 6.35549 4.24869 6.35549 4.69071C6.35549 5.13274 6.1799 5.55665 5.86734 5.86921"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
